import {Content} from "#/src/pages/blog/@id/Content";
import {Header} from "#/src/pages/blog/@id/Header";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";

export {Page}

function Page() {
  return <>
    <LiveStreamersHeader/>
    <Header/>
    <Content/>
  </>
}
